import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Accordion, Card } from 'react-bootstrap';
import menudata from '../config/MenuData';
import CategoryInput from '../components/CategoryInput';
import InputErrors from '../components/errors/InputErrors';


const data = menudata.map(row => row);

const CategoryTree = (props) => {
    const [showTab, setShowTab] = useState(data[0].categories[0].name);
    const [cart, setCart] = useState([]);
    const [nrb, setNrb] = useState(0);
    const [onlyCharges, setOnlyCharges] = useState();
    const [isOnlyOneSelected, setIsOnlyOneSelected] = useState(false);
    const [errors, setErrors] = useState([]);


    useEffect(() => {
        setIsEditableAndNewCharges();
    }, []);

    function setIsEditableAndNewCharges() {
        let newCharges = [];
        if (data[0].categories) {
            data[0].categories.forEach(element => {
                if (element.subcategory) {
                    element.subcategory.forEach(subcategory => {
                        if (subcategory.charges.length > 0) {
                            subcategory.charges.forEach(charge => {
                                if (charge.price === 0) {
                                    charge.isEditable = true;
                                }
                                else {
                                    charge.isEditable = false;
                                }
                                newCharges.push(charge);
                            });
                        }
                    });
                }
                else {
                    element.charges.forEach(charge => {
                        if (charge.price === 0) {
                            charge.isEditable = true;
                        }
                        else {
                            charge.isEditable = false;
                        }
                        newCharges.push(charge);
                    });
                }
            });
        }
        setOnlyCharges(newCharges);
    };


    function onChangePrice(charge, e) {
        console.log(e)
        let oldCharge = charge;
        charge.isEditable = true;
        charge.price = +e.target.value;
        const updatedCartState = cart;
        if (document.getElementById(`custom-checkbox-${charge.id}`).checked === true) {
            if (!containsObject(oldCharge, cart)) {
                updatedCartState.push(charge);
            }
            else {
                var index = updatedCartState.indexOf(oldCharge)
                if (index !== -1) {
                    updatedCartState.splice(index, 1);
                }
                updatedCartState.push(charge);
            }
            setCart(updatedCartState)
            props.parentData(updatedCartState);
        }
    };

    function setNewChargesValues(newCharges) {
        if (data[0].categories) {
            newCharges.forEach(newCharge => {
                data[0].categories.forEach(element => {
                    if (element.subcategory) {
                        element.subcategory.forEach(subcategory => {
                            if (subcategory.charges.length > 0) {
                                subcategory.charges.forEach(charge => {
                                    if (charge.id === newCharge.id) {
                                        charge.isEditable = newCharge.isEditable;
                                        charge.isDisabled = newCharge.isDisabled;
                                        charge.name = newCharge.name;
                                        charge.price = newCharge.price;
                                        charge.nrb = newCharge.nrb;
                                        charge.kod_przelewu = newCharge.kod_przelewu;
                                    }

                                });
                            }
                        });
                    }
                    else {
                        element.charges.forEach(charge => {
                            if (charge.id === newCharge.id) {
                                charge.isDisabled = newCharge.id;
                                charge.name = newCharge.name;
                                charge.price = newCharge.price;
                                charge.nrb = newCharge.nrb;
                                charge.kod_przelewu = newCharge.kod_przelewu;
                            }
                        });
                    }
                });
            });
        }
    };

    function containsObject(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i] === obj) {
                return true;
            }
        }
        return false;
    };

    function addDisabledConditionally(charges, position) {
        charges.forEach(element => {
            if (!element.checked && element.id !== position.id) {    //wyszarzyć resztę oprócz tego co jest aktualnie zaznaczany
                element.isDisabled = true;
            }

        });
    };

    function removeDisabled(charges) {
        charges.forEach(element => {

            element.isDisabled = false;
        });
    };

    function disableAllOtherCharges(charges, position) {
        charges.forEach(element => {
            if (element.id !== position.id) {
                element.isDisabled = true;
            }
        });
    };

    function disableAllEditables(charges) {
        charges.forEach(element => {
            if (element.isEditable === true) {
                element.isDisabled = true;
            }
        });
    };

    function disableDifferentNrb(charges, nrb) {
        charges.forEach(element => {
            if (element.nrb !== nrb) {
                element.isDisabled = true;
            }

        });
    };

    function checkErrors(position, checked, charges, cart) {
        removeDisabled(charges);
        setErrors([]);
        if (cart.length >= 10) {
            //funkcja ktora przechodzi po wszystkich elementach i ustawia im isDisabled zależnie czy jest checked czy nie
            addDisabledConditionally(charges, position);
            setErrors(errors => [...errors, "Osiągnięto maksymalną liczbę opłat."])
        }
        if (cart.length > 0) {
            if (position.isEditable) {
                disableAllOtherCharges(charges, position);
                setIsOnlyOneSelected(true);
                setErrors(errors => [...errors, "Łączenie opłat stałych wraz z edytowalnymi jest niedostępne."])
            }
            else {
                disableAllEditables(charges);
                setErrors(errors => [...errors, "Łączenie opłat stałych wraz z edytowalnymi jest niedostępne."])
            }

            if ((position.nrb === nrb || nrb === 0)) {
                disableDifferentNrb(charges, position.nrb)
                setErrors(errors => [...errors, "Niektóre opłaty są zablokowane ze względu na inny docelowy numer konta."])
            }
        }
    };

    function handleOnChange(position, checked) {
        const updatedCartState = cart;
        if (checked) {
            updatedCartState.push(position);
            position.checked = true;
        }

        else {
            position.checked = false;
            var index = updatedCartState.indexOf(position)
            if (index !== -1) {
                updatedCartState.splice(index, 1);
            }
            if (isOnlyOneSelected === true) {
                removeDisabled(onlyCharges);
                setIsOnlyOneSelected(false);
            }
        };
        checkErrors(position, checked, onlyCharges, updatedCartState);
        setNrb(position.nrb)
        if (cart.length === 0) {
            setNrb(0)
        }
        setCart(updatedCartState)
        props.parentData(cart);
        setNewChargesValues(onlyCharges);
    };

    return (
        <div className="d-flex-column">
            <Tabs defaultActiveKey="1" id="controlled-tab" activeKey={showTab} onSelect={(k) => setShowTab(k)}>
                {data[0].categories ? data[0].categories.map((row, index) => {
                    return (
                        <Tab key={row.id} eventKey={row.name} title={row.name}>
                            {row.subcategory ? row.subcategory.map((subcategory, subcat_index) => {
                                return (
                                    <Accordion key={subcat_index} defaultActiveKey={subcategory.id} >
                                        <Card key={subcat_index}>
                                            <Accordion.Toggle as={Card.Header} eventKey={subcategory.id} style={{ cursor: "pointer" }}>
                                                {subcategory.name}
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={subcategory.id}>
                                                <Card.Body>
                                                    {(subcategory.charges.length > 0) ? subcategory.charges.map((charge, charge_index) => {
                                                        return (
                                                            <div key={charge_index}>
                                                                <CategoryInput charge={charge} subdata={subcategory} handleOnChange={handleOnChange} onChangePrice={onChangePrice} />
                                                            </div>
                                                        )
                                                    }) : ""}
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                )
                            }) : row.charges.map((charges, index) => {
                                return (
                                    <Card key={index}>
                                        <Card.Body>
                                            <CategoryInput charge={charges} subdata={row} handleOnChange={handleOnChange} onChangePrice={onChangePrice} />
                                        </Card.Body>
                                    </Card>
                                )
                            })}
                        </Tab>

                    )
                }) : ""}
            </Tabs>
            <InputErrors errors={errors} />
        </div>
    );
}

export default CategoryTree;